module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_6-c995731f122f235bb08b4ff207a32a39.jpg";